export const GET_USERS_REQUEST = 'GET_USERS_REQUEST'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'



// WEBPACK FOOTER //
// ./src/constants/user.js